import { render } from "./CampaignMapping.vue?vue&type=template&id=67752341"
import script from "./CampaignMapping.vue?vue&type=script&lang=js"
export * from "./CampaignMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__